import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import Icon from 'components/icon/icon'
import ProfilePicture from 'components/profile/profile-picture'
import { connect } from 'react-redux'

import { isMobile } from 'utils'
import { withRouter } from 'react-router'

import { refreshUserData } from 'state/actions'

class PopMenu extends Component {
    state = {
        tabState: 0,
        hasRequestedData: false,
        isLoading: false
    }

    UNSAFE_componentWillUpdate = nextProps => {
        if(nextProps.isOpen && !this.props.isOpen && !this.props.isStatuses){
            this.props.refreshUserData('history', _ => {
                this.setState({
                    hasRequestedData: true,
                    isLoading: false
                })

            })
        }
    }

    setTabState = tabState => {
        this.setState({
            tabState
        })
    }

    render(){
        const { 
            userData,
            currentAccount,
            isOpen,
            closeMenu,
            options,
            isStatuses,
            selectedOptionId,
            selectCallback,
            shouldGoUp
        } = this.props 

        /*const reversedHistoryItems = userData.history_items ? userData.history_items : []

        reversedHistoryItems.sort((a,b) => {
            return b - a
        }) */

        let cssTransitionGroupClassName = ''

        // all for dashboard-tasks
        if(isStatuses){
            cssTransitionGroupClassName += 'pop-menu-container smooth-collapse-container'

            if(shouldGoUp){
                cssTransitionGroupClassName += ' inverted'
            }
        }

        return (
            <CSSTransitionGroup 
                transitionName="pop" 
                transitionEnterTimeout={1} 
                transitionLeaveTimeout={100} 
                className={cssTransitionGroupClassName}
            >
                { isOpen ?
                    <div className={'pop-menu'} onClick={isMobile() ? closeMenu : null} ref={ref => this.innerRef = ref}>
                        <div onClick={e => e.stopPropagation()}>
                            { /* (isMobile() && false) &&
                                <ul className="tabs">
                                    { ['Settings','History'].map((label, index) => {
                                        return (
                                            <li key={index}>
                                                <button onClick={_ => {this.setTabState(index)}} className={tabState != index ? 'inactive' : null}>
                                                    { label }
                                                </button>
                                            </li>
                                        )
                                    }) }
                                </ul>
                                */}
                                <ul onClick={e => {e.stopPropagation()}}>
                                    {
                                        (isMobile() && !isStatuses) &&
                                        <li className="mobile-only">
                                            <span>
                                                <ProfilePicture url={userData.image_url} isTiny={true} /> 
                                                <span>
                                                    { userData.first_name+' '+userData.last_name }
                                                    <em>
                                                        { currentAccount.name }
                                                    </em>
                                                </span>
                                            </span>
                                        </li>
                                    }
                                    {
                                        options.map((option, index) => {
                                            let className = ''

                                            if(selectedOptionId && selectedOptionId == option.id){
                                                className += ' selected'
                                            }

                                            return (
                                                <li key={index}>
                                                    { isStatuses ?
                                                        <label 
                                                            onClick={e => {
                                                                e.preventDefault()
                                                                e.stopPropagation()
                                                                closeMenu()
                                                                selectCallback(option.id)
                                                            }}
                                                            className={className}
                                                        >
                                                            <em className={'status-icon colour-id-'+option.id} />
                                                            { option.label }
                                                        </label>
                                                    
                                                    :
                                                        <button onClick={e => {
                                                            e.stopPropagation()
                                                            closeMenu()
                                                            option.callback()
                                                        }}>    
                                                            {option.icon &&
                                                                <Icon name={option.icon} />
                                                            }
                                                            { option.label }
                                                        </button>
                                                    }
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                                { /*}
                                // this used to be in a ternary
                                <ul className="history-list">
                                    {
                                        (hasRequestedData && !isLoading && !reversedHistoryItems.length) &&
                                        <AlertBanner low={false} title="Nothing to show just yet." body="This'll hold your recent activity, when you've got some." />
                                    }
                                    {
                                        !hasRequestedData && isLoading ?
                                        <Loader visible={true} />
                                        :
                                        reversedHistoryItems.map(historyItemId => {
                                        const historyItem = allHistoryItems[historyItemId]
                                        let item = null
                                        let icon = null
                                        let project = null
                                        let url = match.url+'/projects/'

                                        switch(historyItem.item_type){
                                            case 'App\\Project':
                                                item = allProjects[historyItem.item_id]

                                                if(!item){
                                                    return null
                                                }

                                                if(item){
                                                    url += item.slug
                                                }
                                                //icon = 'star'
                                                break
                                            case 'App\\Task':
                                                item = allTasks[historyItem.item_id]

                                                if(!item){
                                                    return null
                                                }

                                                const milestone = allMilestones ? allMilestones[item.milestone_id] : null

                                                if(!milestone){
                                                    return null
                                                }

                                                project = allProjects ? allProjects[milestone.project_id] : null

                                                if(!project){
                                                    return null
                                                }

                                                url += project.slug+'/tasks/'+item.id
                                                //icon = 'sticky-note-o'
                                                break
                                        }

                                        if(!item || !item.name){
                                            return null
                                        }

                                        return (
                                            <li key={historyItem.id}>
                                                <Link to={url} onClick={_ => {
                                                    this.props.closeMenu()
                                                }}>
                                                    { item.name }
                                                    <span>
                                                        { project ? 'From '+project.name+' • ' : null }
                                                        <TimeAgo date={formatByTimeZone(historyItem.created_at, 'YYYY-MM-DD HH:mm:ss')} />
                                                    </span>
                                                </Link>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                                */
                                }
                        </div>
                    </div>
                    : null
                }
            </CSSTransitionGroup>
        )
    }
}

const mapStateToProps = state => {
    return {
      allHistoryItems: state.account.entities.history_items,
      allProjects: state.account.entities.projects,
      allTasks: state.account.entities.tasks,
      allMilestones: state.account.entities.milestones
    };
}
  
export default withRouter(connect(mapStateToProps, {
    refreshUserData, 
})(PopMenu))